var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.componentName,{tag:"component",attrs:{"nested":"","question":{ issue: _vm.issue }},on:{"change":_vm.onChangeValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }